// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__nP5z2","checkbox__active":"checkbox_checkbox__active__KS0aQ","container":"checkbox_container__1Gaai","title":"checkbox_title__Og5FY"};